import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const searchBikesByVariant = async (ref_bike_model) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_VARIANTS}?modelId=${ref_bike_model}&limit=25`,
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: `Get bike variant: ${e.message}`,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/search_by_variants_request.js